// The primary reason why we use this function to check `process.env` is to ensure that the checks
// don't get preprocessed/removed during the dead code removal phase in UglifyJS. This was causing
// an issue for Circle builds because the placeholder values were getting evaluated as false and
// getting stripped from the minified js build. So even when we replaced the placeholders in the
// built js with "true", the app would function as if the flag were set to false. To prevent that,
// all `process.env` checks in the app code should go through utility methods like this one.
const flagEnabled = envField => process.env[envField] === 'true'

export { flagEnabled }
